import {useHistory} from "react-router";
import Layout from "@/layout/Layout";
import MButton from "@/components/atom/MButton";
import React, {useEffect} from "react";
import globalStyle from "@/styles/Global.scss";
import {PaygentForm} from "@/components/PaygentForm";

export const Purchase = () => {
  const history = useHistory()

  useEffect(() => {
    (async () => {
    })()
  }, [])

  const goBack = () => {
    history.goBack()
  }

  return (
    <>
      <Layout category={'WA'} title={'購入'}>
        <div className={globalStyle.container}>
          <div>
            <span>30日分の利用を購入</span>
            <div>
              <div>金額：500円</div>
              <PaygentForm price={500} cardId={1} ></PaygentForm>
              <div>支払いはペイジェント社のページに移動します。</div>
            </div>
          </div>
          <MButton image={'back.png'} onClick={goBack} value={'戻る'}/>
        </div>
      </Layout>
    </>
  )
}
